import { render } from "./FuncionalidadeView.vue?vue&type=template&id=e92045ee"
import script from "./FuncionalidadeView.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__